import { Injectable } from '@angular/core';
import { RoutePathBuilder } from '@ngspot/route-path-builder';
import { ACCOUNT } from './route-strings';

@Injectable({ providedIn: 'any' })
export class RoutesForAccount extends RoutePathBuilder {
  signIn() {
    return this.url(ACCOUNT.SIGNIN);
  }

  register() {
    return this.url(ACCOUNT.REGISTER);
  }
}
